import styled, { css } from 'styled-components'
import { Box } from '@branch-messenger/willow-ui'
import { mobileStyles } from '@styles/utils'

export const StyledFlowCard = styled(Box).attrs<{ $embedded?: boolean }>({
  $flex: 1,
  $fullWidth: true,
  $display: 'flex',
  $direction: 'column',
  $align: 'stretch',
})`
  position: relative;
  overflow: hidden;
  height: 100%;
  max-width: 360px;
  max-height: 536px;
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow:
    0 0 #0000,
    0 0 #0000,
    0 4px 6px -1px rgb(0 0 0 / 0.1),
    0 2px 4px -2px rgb(0 0 0 / 0.1);

  ${mobileStyles(css`
    box-shadow: none;
    border-radius: 0;
    max-height: unset;
    max-width: unset;
    padding: 0;
  `)};

  ${({ $embedded }) =>
    $embedded &&
    css`
      height: 100svh;
      max-width: unset;
      max-height: unset;
      border-radius: 0;
      box-shadow: none;
    `}
`

export const StyledFlowCardMain = styled(Box).attrs<{}>({
  $flex: 1,
  $pb: 2,
  $display: 'flex',
  $direction: 'column',
})`
  padding-top: 0;
  overflow-y: auto;

  /* shadow for scroll */
  background:
    linear-gradient(white 30%, rgba(255, 255, 255, 0)) center top,
    linear-gradient(rgba(255, 255, 255, 0), white 70%) center bottom,
    radial-gradient(
        farthest-side at 50% 0,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      center top,
    radial-gradient(
        farthest-side at 50% 100%,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      center bottom;
  background-repeat: no-repeat;
  background-size:
    100% 40px,
    100% 40px,
    100% 14px,
    100% 14px;
  background-attachment: local, local, scroll, scroll;
`

export const StyledFlowCardFooter = styled(Box).attrs({
  $p: 4,
  $display: 'flex',
  $direction: 'column',
  $align: 'stretch',
})`
  ${mobileStyles(css`
    padding: ${({ theme }) => theme.space[4]};
  `)}
`

export const StyledFlowCardTop = styled(Box).attrs({
  $fullWidth: true,
  $display: 'flex',
  $justify: 'space-between',
  $p: 2,
})`
  z-index: 1;
  position: sticky;
  top: 0;
  left: 0;
  transition: background-color 100ms ease;
  min-height: 48px;
`

export const StyledFlowCardAlertContainer = styled(Box).attrs({
  $display: 'flex',
  $fullWidth: true,
  $align: 'center',
  $gap: 4,
  $p: 4,
})`
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: ${({ theme }) => theme.radii.lg};
  background-color: ${({ theme }) => theme.colors.background};
`
